import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import AddressEdition from './AddressEdition';

import {
    defaultShippingAddress,
    delShippingAddress, myShippingAddresses
} from '../../../actions/user-account/address/ua_address';

//CSS
import './address.css';

//MUI
import {
    Typography, Breadcrumbs, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle, Button,
    Snackbar, Box, Card, CardActions, CardContent,
    Container, Grid, FormGroup, FormControlLabel,
    Checkbox, Alert as MuiAlert, useMediaQuery
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { USER_ADDRESS } from '../../../constants/user/user_constants';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddressComponent = () => {
    const matches = useMediaQuery('(max-width: 950px)');

    // direcciones de envío del usuario
    const [addresses, setAddresses] = useState([]);
    const [activeAddress, setActiveAddress] = useState(USER_ADDRESS);
    const { _id } = activeAddress;

    useEffect(() => {
        getShippingAdresses();
    }, []);

    // direcciones de envío del usuario
    const getShippingAdresses = async () => {
        const req = await myShippingAddresses();
        if (req.status)
            setAddresses(req.resp);
    };

    //Scrollto
    const testRef = useRef(null);
    const scrollToElement = () => testRef.current.scrollIntoView({ behavior: 'smooth' });

    //Ocultar o mostrar formulario
    const [showForm, setShowForm] = useState(false)
    const showAddress = (address_id) => (e) => {
        e.preventDefault();
        const found = addresses.find(e => e._id === address_id);
        if (found) {
            setActiveAddress(found);
            setShowForm(true);
            setTimeout(() => { scrollToElement() }, 1);
        }
    }

    //Oculta el formulario
    const closeForm = () => {
        setShowForm(false);
        window.scrollTo({
            top: 0,
            //behavior: 'smooth',
        })
    }

    //Dialog eliminar
    const [dialogDelete, setDialogDelete] = useState(false)
    const openDialogDelete = (address_id) => () => {
        const found = addresses.find(e => e._id === address_id);
        if (found) {
            setActiveAddress(found);
            setDialogDelete(true);
        }
    };
    const CloseDialogDelete = () => {
        setDialogDelete(false);
    };

    //Alert eliminar
    const [alertDelete, setAlertDelete] = useState(false)
    const closeAlertDelete = () => {
        setAlertDelete(false);
    }

    //Funcion cuando acepta editar los cambios en el dialog
    const openAlertDelete = async () => {
        setDialogDelete(false);
        await delShippingAddress(
            _id, setAddresses, setActiveAddress,
            closeForm, setAlertDelete
        );
    };

    // elegir dirección de envío como predeterminada
    const markAsDefault = (_id, by_default) => async () => {
        if (!by_default)
            await defaultShippingAddress(_id, setAddresses);
    };

    return (
        <>
            {/* Titulo y breadcrumb */}
            <Container maxWidth='xl' sx={{ mt: matches ? 5 : 18 }}>
                <Typography variant='h4' sx={{ fontWeight: 'light' }} gutterBottom>Mis direcciones de envío</Typography>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" to="/mi-cuenta">
                        Mi cuenta
                    </Link>
                    <Typography color="text.primary">Direcciones de envío</Typography>
                </Breadcrumbs>
            </Container>
            {/* Fin titulo y breadcrumb */}

            {/* Contenido de direcciónes */}
            <Container maxWidth='xl' sx={{ mt: 5 }} className="last-view">
                {/* Row */}
                <Grid container spacing={3}>
                    {/* Dirección */}
                    {
                        addresses.length <= 0 ?
                            <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                                <Box sx={{ position: 'relative', textAlign: 'center', p: 2 }}
                                    className="box-address">
                                    <Typography variant='h6' sx={{ fontWeight: 'light' }}>
                                        Por el momento no cuenta con ninguna dirección de envío
                                    </Typography>
                                </Box>
                            </Grid>
                            :
                            addresses.map(({
                                _id, name, street, ext_num, int_num, lastname,
                                colony, city, state, postalcode, tel, by_default
                            }) =>
                                <Grid item xl={4} lg={4} md={6} sm={12} xs={12} key={_id}>
                                    <Card sx={{ boxShadow:
                                        by_default ? '0 2px 4px 2px rgb(33,150,243)'
                                        : '0 2px 4px 2px rgb(0 0 0 / 20%)'
                                        }}>
                                        <CardContent>
                                            <Typography variant='body1' sx={{ fontWeight: '600' }}>{name} {lastname}</Typography>
                                            <Typography variant='body1'>{`${street} #${ext_num} `}
                                                {int_num ? `interior ${int_num}` : ''}</Typography>
                                            <Typography variant='body1'>{colony}</Typography>
                                            <Typography variant='body1'>{`${city}, ${state} ${postalcode}`}</Typography>
                                            <Typography variant='body1'>Número de teléfono: {tel}</Typography>
                                            <FormGroup>
                                                <FormControlLabel control={
                                                    <Checkbox checked={ by_default }
                                                        onChange={ markAsDefault(_id, by_default) }
                                                    />
                                                } label={ by_default ? "Predeterminada" : "" } />
                                            </FormGroup>
                                        </CardContent>
                                        <CardActions>
                                            <Button onClick={ showAddress(_id) }>
                                                Editar
                                            </Button>
                                            <Button onClick={ openDialogDelete(_id) }>
                                                Eliminar
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            )
                    }

                    {/* Fin dirección */}

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                        <Link to={"/mi-cuenta/nueva-direccion-de-envio"} style={{ color: '#000', textDecoration: 'none' }}>
                            <Box sx={{ position: 'relative', textAlign: 'center', p: 2 }}
                                className="box-address">
                                <Typography variant='h6' sx={{ fontWeight: '600' }}>
                                    <AddIcon /> <br /> Agregar dirección
                                </Typography>
                            </Box>
                        </Link>
                    </Grid>

                </Grid>
                {/* Fin row */}

                {/* Referencia para scroll */}
                <div ref={testRef}></div>
            </Container>
            {/* Fin contenido de direcciones */}

            {/* Formulario para editar o agregar direcciones */}
            <Container maxWidth='xl' className="last-view">
                {
                    showForm &&
                    <AddressEdition hide={() => closeForm()}
                        addresses={addresses}
                        setAddresses={setAddresses}
                        activeAddress={activeAddress}
                        setActiveAddress={setActiveAddress} />
                }
            </Container>
            {/* fin formulario para editar o agregar direcciones */}

            {/* Dialog */}
            <Dialog
                open={dialogDelete}
                onClose={CloseDialogDelete}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"¿Está seguro que desea eliminar esta dirección?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Esta dirección no puede recuperarse. Sin embargo, podrá volver a ingresar la información en otra dirección
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={CloseDialogDelete}>Cancelar</Button>
                    <Button onClick={openAlertDelete}>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={alertDelete} autoHideDuration={2500} onClose={closeAlertDelete}>
                <Alert onClose={closeAlertDelete} severity="error" sx={{ width: '100%' }}>
                    Se ha eliminado correctamente
                </Alert>
            </Snackbar>
        </>
    );
};

export default AddressComponent;